import req from "@/utils/axios.js";

export default {
    // 获取标签分类列表
    getTagCategoryList(data) {
        return req.get("/wxShop/tagCategory/list", {
            ...data
        })
    },
    // 获取运营标签列表
    getTagList(data) {
        return req.get("/wxShop/tag/list", {
            ...data
        })
    },
    // 获取优惠券列表 
    getCouponList(data) {
        return req.post("/wxShop/coupon/list", {
            ...data
        })
    },

    // 省市区 map
    _areaMap(data) {
        return req.get("/region/list", data)
    }
}